import { Component } from '@angular/core';

import {
  SkyFileItem,
  SkyFileDropChange,
  SkyFileLink
} from '../../core';


export class SkyFileAttachmentDemoComponent {
  public filesToUpload: SkyFileItem[];
  public allItems: (SkyFileItem | SkyFileLink)[];
  public linksToUpload: SkyFileLink[];
  public rejectedFiles: SkyFileItem[];
  public maxFileSize: number = 4000000;
  public acceptedTypes: string = 'image/png,image/jpeg';

  constructor() {
    this.filesToUpload = [];
    this.rejectedFiles = [];
    this.allItems = [];
    this.linksToUpload = [];
  }

  public filesUpdated(result: SkyFileDropChange) {
    this.filesToUpload = this.filesToUpload.concat(result.files);
    this.rejectedFiles = this.rejectedFiles.concat(result.rejectedFiles);
    this.allItems = this.allItems.concat(result.files);
  }

  public linkAdded(result: SkyFileLink) {
    this.linksToUpload = this.linksToUpload.concat(result);
    this.allItems = this.allItems.concat(result);
  }

  public validateFile(file: SkyFileItem) {
    if (file.file.name.indexOf('a') === 0) {
      return 'You may not upload a file that begins with the letter "a."';
    }
  }

  public deleteFile(file: SkyFileItem | SkyFileLink) {
    this.removeFromArray(this.allItems, file);
    this.removeFromArray(this.filesToUpload, file);
    this.removeFromArray(this.linksToUpload, file);
  }

  private removeFromArray(items: any[], obj: SkyFileItem | SkyFileLink) {
    if (items) {
      const index = items.indexOf(obj);

      if (index !== -1) {
        items.splice(index, 1);
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-file-attachment-demo',
  template: `<div style="width: 60%; margin-left: auto; margin-right: auto;">
  <sky-file-drop
    (filesChanged)="filesUpdated($event)"
    (linkChanged)="linkAdded($event)"
    [maxFileSize]="maxFileSize"
    [validateFn]="validateFile"
    [allowLinks]="true"
    [acceptedTypes]="acceptedTypes">
  </sky-file-drop>

  <sky-alert
    [alertType]="'danger'"
    [closeable]="true"
    *ngIf="rejectedFiles.length > 0">
    The file <strong>{{rejectedFiles[rejectedFiles.length - 1].file.name}}</strong> is invalid.
    Reason: {{rejectedFiles[rejectedFiles.length - 1].errorType}} violation.
    Error param: {{rejectedFiles[rejectedFiles.length - 1].errorParam}}
  </sky-alert>

  <div *ngFor="let file of allItems">
    <sky-file-item
      [fileItem]="file"
      (deleteFile)="deleteFile($event)">
    </sky-file-item>
  </div>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
